import React, { FC } from 'react';
import { AdfoxContextData, AdfoxContextProvider } from '../../../context/AdfoxContext';
import { PParams } from '../../../../types';
import { AdfoxBannerContainer } from '../../../../AdfoxBannerContainer';
import { useDeviceType } from '@cian/ui-kit';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextData['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'journal',
  name__DEPRECATED: 'Journal_maipage_footer',
};

const P_PARAMS: PParams = { p1: 'ddcgu', p2: 'y' };

const SIZE: AdfoxContextData['size'] = { height: '560px', width: '100%' };

export const AdfoxBannerMainPageFooter: FC = () => {
  const deviceType = useDeviceType();

  return deviceType === 'desktop' ? (
    <AdfoxContextProvider
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      place="mainPageFooter"
      size={SIZE}
      pParams={P_PARAMS}
    >
      {() => <AdfoxBannerContainer />}
    </AdfoxContextProvider>
  ) : null;
};
